import { ComputoTasksPage } from "./Projects";

// Módulo Proyectos (sidebar Ingeniería → Proyectos → "Proyecto").
// Espejo exacto del módulo Cómputo, filtrado por tareas de tipo "proyecto"
// (presupuestos "De Proyecto").
export default function IngenieriaComputo() {
  return <ComputoTasksPage tipo="proyecto" />;
}
